import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';

interface SetSystemUnavailableCommand {
  value: boolean;
}

export const setSystemUnavailable: GlobalStateCommandFactory<
  SetSystemUnavailableCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.systemUnavailable = command.value;
  });
};
